module.exports = __webpack_public_path__ + "static/img/6.320d37c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/6.png
// module id = t16U
// module chunks = 0